export default __webpack_public_path__ + "static/media/green-bagel.a4e86509.svg";